import { Toolbar } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import SyncStatusBanner from "../common/SyncStatusBanner";
import SubscriptionBanner from "../common/SubscriptionBanner";

function Main({ drawerWidth }) {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Toolbar />
      <SubscriptionBanner />
      <SyncStatusBanner />
      <Box sx={{ padding: { xs: "12px 8px", sm: "20px 12px", md: "30px 15px" }, background: (theme) => theme.palette.mode === "dark" ? "#121212" : "#F7F7F8", flex: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}

export default Main;
